// Copyright (c) 2016 Deere & Company

import './registrations-review.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import Formatting from '../state/formatting';
import NumberOfRecordsFound from '../../../shared/components/number-of-records-found/index';
import RegistrationStatus from '../state/registration-status';
import RegistrationsReviewCriteria from './registrations-review-criteria';
import RegistrationsReviewReport from '@deere/cps-it.warranty-model-factory/lib/registrations-review';
import ReportGrid from '../../shared/components/report-grid';
import ReportHeader from '../../shared/components/report-header';
import ReportHiddenColumns from '../../shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import View from '../state/view';
import WarrantyAgGridDatePicker from '../../shared/components/ag-grid-date-picker';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToCSV} from '../../../reports/shared/services/export-to-csv';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getDefaultReportLayout} from '../../shared/services/report-variant';
import {getRegistrationsReviewColumnDefinitions} from '../report-services/column-definitions';
import {scrollToAndResizeReport} from '../../shared/services/scroll-window';

function handleCreateReportClick() {

    this.actions.toggleReportIsScrollable();
    this.actions.resetSearchResults();
    this.actions.createRegistrationsReviewReport();

}

function handleDealersSelect(dealer, isSelected) {

    this.actions.selectRegistrationsReviewDealer(dealer, isSelected);

}

function handleSelectAllDealers() {

    this.actions.selectAllRegistrationsReviewDealers(this.selectedAccounts);

}

function handleSelectAllRegistrationStatuses() {

    this.actions.selectAllRegistrationStatuses();

}

function handleDeliveryDateChange(deliveryDateRange) {

    this.actions.updateDeliveryDate(deliveryDateRange);

}

function handleRegistrationDateChange(registrationDateRange) {

    this.actions.updateRegistrationDate(registrationDateRange);

}

function handleRegistrationStatusSelect(status, isSelected) {

    this.actions.selectRegistrationStatus(status, isSelected);

}

function handleGridApiDefinition(params) {

    let defaultColumnState,
        defaultSortModel;

    this.actions.createAgGridApi(params.api, params.columnApi);

    if (this.selectedLayout && this.selectedLayout.name && !this.isInitialLoad) {

        const defaultLayout = this.layouts.find(layout => !layout.name);

        defaultColumnState = defaultLayout.columnState;
        defaultSortModel = defaultLayout.sortModel;

    } else {

        defaultColumnState = params.columnApi.getColumnState();
        defaultSortModel = params.api.getSortModel();

        this.actions.updateReportProperty('isInitialLoad', false);

    }

    this.actions.updateDefaultLayout(defaultColumnState, defaultSortModel);

    if (this.selectedLayout && this.selectedLayout.name) {

        params.columnApi.setColumnState(this.selectedLayout.columnState);
        params.api.setSortModel(this.selectedLayout.sortModel);
        params.api.setFilterModel(this.selectedLayout.filterModel);

    } else {

        const defaultLayout = getDefaultReportLayout(defaultColumnState, defaultSortModel);

        this.actions.updateReportProperty('selectedLayout', defaultLayout);

    }

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

function handleExportToCsv() {

    const fileName = 'registration-review';

    return exportToCSV(fileName, this.gridApi);

}

function handleReset() {

    this.actions.resetCriteria(this.selectedAccounts);
    this.actions.resetSearchResults();
    this.actions.updateShowNoResultsFound(false);
    this.actions.resetRegistrationReports();

}

class RegistrationsReview extends Component {

    async componentWillMount() {

        this.props.actions.readRegistrationStatuses();
        this.props.actions.selectAllDealersOnLoad(this.props.selectedAccounts);
        await this.props.actions.getReportLayouts('registration-review');
        this.props.actions.updateGridLayouts(this.props.layouts, getRegistrationsReviewColumnDefinitions(this.context.user.privacy));

    }

    componentDidUpdate(prevProps) {

        if (this.props.reportIsScrollable && this.props.report.length) {

            this.props.actions.resetReportIsScrollable();

            scrollToAndResizeReport();

        }

        const isFirstRun = !prevProps.report.length && !prevProps.showNoResultsFound;
        const layoutWasChanged = this.props.selectedLayout !== prevProps.selectedLayout;
        const readyToApplyLayout = this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable;

        if ((isFirstRun || layoutWasChanged) && readyToApplyLayout) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetSearchResults();
        this.props.actions.updateShowNoResultsFound(false);
        this.props.actions.resetRegistrationReports();
        this.props.actions.resetReportVariant();

    }

    render() {

        const canRunReport = this.props.selectedDealers.length > 0 && this.props.registrationStatus.selected.length > 0;

        const gridOptions = {
            dateComponentFramework: WarrantyAgGridDatePicker
        };

        return (
            <section className='registrations-review'>
                <h2 className='registrations-review-title'>
                    <FormattedMessage id='REGISTRATIONS_REVIEW'/>
                    <FavoriteIcon
                        id='REGISTRATIONS_REVIEW'
                        route={this.props.pathName}
                    />
                </h2>
                <RegistrationsReviewCriteria
                    canExport={this.props.report.length > 0}
                    canRunReport={canRunReport}
                    deliveryDate={this.props.deliveryDate}
                    onCreateReport={this.props::handleCreateReportClick}
                    onDealerSelect={this.props::handleDealersSelect}
                    onDeliveryDateChange={this.props::handleDeliveryDateChange}
                    onExportToCsv={this.props::handleExportToCsv}
                    onRegistrationDateChange={this.props::handleRegistrationDateChange}
                    onReset={this.props::handleReset}
                    onSelectAllDealers={this.props::handleSelectAllDealers}
                    onSelectAllStatuses={this.props::handleSelectAllRegistrationStatuses}
                    onStatusSelect={this.props::handleRegistrationStatusSelect}
                    registrationDate={this.props.registrationDate}
                    registrationStatus={this.props.registrationStatus}
                    selectedAccounts={this.props.selectedAccounts}
                    selectedDealers={this.props.selectedDealers}
                />
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                {this.props.report.length ?
                    <div>
                        <NumberOfRecordsFound count={this.props.report.length}/>
                        <section className='report'>
                            {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
                            <ReportHeader
                                columnApi={this.props.columnApi}
                                gridApi={this.props.gridApi}
                                reportName='registration-review'
                            />
                            <ReportGrid
                                columnDefs={getRegistrationsReviewColumnDefinitions(this.context.user.privacy)}
                                gridOptions={gridOptions}
                                headerHeight='32'
                                localeText={getAgGridLocaleText()}
                                onColumnVisible={this.props::onColumnRemoved}
                                onGridReady={this.props::handleGridApiDefinition}
                                rowData={this.props.report}
                                rowHeight='32'
                            />
                        </section>
                    </div> :
                    <ShowNoResultsFound showNoResultsFound={this.props.showNoResultsFound}/>}
            </section>
        );

    }

}

RegistrationsReview.displayName = 'RegistrationsReview';
RegistrationsReview.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    deliveryDate: PropTypes.instanceOf(DateRange).isRequired,
    formatting: PropTypes.instanceOf(Formatting).isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    pathName: PropTypes.string.isRequired,
    registrationDate: PropTypes.instanceOf(DateRange).isRequired,
    registrationStatus: PropTypes.instanceOf(RegistrationStatus).isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(RegistrationsReviewReport)),
    reportIsScrollable: PropTypes.bool.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showNoResultsFound: PropTypes.bool.isRequired,
    views: PropTypes.arrayOf(PropTypes.instanceOf(View)).isRequired
};
RegistrationsReview.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default RegistrationsReview;



// WEBPACK FOOTER //
// ./src/reports/registrations-review/components/registrations-review.js